import { UnwrapRef, ComputedRef, computed, reactive } from 'vue';

interface IGenericForm<TFields> {
    fields: UnwrapRef<TFields>;
    errors: string[];
}

interface IUpdateErrorsFunction {
    (fieldHasError: boolean, field: string): void
}

interface IFormCreatorResponse<TFields> {
    form: IGenericForm<UnwrapRef<TFields>>;
    valid: ComputedRef<boolean>;
    updateErrors: IUpdateErrorsFunction
}

export function useFormCreator<TFields> (fields: UnwrapRef<TFields>): IFormCreatorResponse<TFields> {
  // REFS
  const form = reactive<IGenericForm<TFields>>({
    fields: fields,
    errors: []
  });

  // METHODS
  const updateErrors: IUpdateErrorsFunction = (fieldHasError: boolean, field: string): void => {
    if (fieldHasError) {
      form.errors.push(field);
    } else {
      form.errors = form.errors.filter(e => e !== field);
    }
  };

  // COMPUTED
  const valid = computed(() => !form.errors.length);

  return {
    form,
    valid,
    updateErrors
  };
}
